import { useCallback, useEffect, useState } from "react";
import { ticketService } from "../services/ticketService";

export function useTickets() {
  const [tickets, setTickets] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTickets = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await ticketService.listTickets();
      setTickets(response.data ?? response ?? []);
    } catch (err: any) {
      setError(err.message ?? "Impossible de charger les tickets.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  return { tickets, loading, error, reload: fetchTickets };
}